import { render } from "./ObjManageList.vue?vue&type=template&id=74236e82&scoped=true"
import script from "./ObjManageList.vue?vue&type=script&lang=js"
export * from "./ObjManageList.vue?vue&type=script&lang=js"

import "./ObjManageList.vue?vue&type=style&index=0&id=74236e82&scoped=true&lang=scss"

import exportComponent from "/Users/adrianfraczak/Projects/Actual/GC/admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74236e82"]])

export default __exports__